import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PlansDataService} from './plans-data.service';
import {map} from 'rxjs';
import {AuthComponent} from '../auth/auth.component';
import {PaymentComponent} from '../payment/payment.component';
import {environment} from '../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {DataService} from '../../../../../firebase/src/lib/services/data.service';
import {PromoHandlerService} from '../../../../../shared/src/lib/components/promo-handler/promo-handler.service';
import {ViewportScroller} from '@angular/common';
import {TherapistService} from '../../services/therapist.service';

@Component({
    selector: 'app-plans',
    templateUrl: './plans.component.html',
    styleUrls: ['./plans.component.scss']
})
export class PlansComponent implements OnInit {
    @Input() submitButtonText = 'Пройти тест';
    @Input() title = 'Пакети';
    @Input() successRoute = null;
    @Input() requestType: 'capture' | 'authorize' = null;
    @Input() returnUrl: string;

    testName = 'anxiety';
    environment = environment;

    @Output() paymentSuccess: EventEmitter<any> = new EventEmitter<any>();
    @Output() loaded: EventEmitter<any> = new EventEmitter<any>();
    items: any[];
    planSetDefaultData = [
        {
            position: 0,
            title: 'Пакети',
            header_description: 'Це як чек-ап психічного стану',
            isBestValue: false,
            recommendations: [
                'AI асистент. Beta версія',
                'Оцінка рівня стресу/вигорання',
                '12 сесій тестування',
                'Оцінка викривлення уваги',
                'Оцінка тривожності та/або депресії',
                'Рекомендації та інсайти',
                'Найкраще для терапевтів (відстеження прогресу клієнтів)'
            ],
            fullPrice: 9.99,
            price: 3.99,
            value: 468,
            btnText: 'Купити',
            subscription: false
        },
        {
            position: 1,
            title: 'Передплата',
            header_description: 'Передплата на свідомий стиль життя',
            isBestValue: true,
            recommendations: [
                'AI асистент. Beta версія',
                'Оцінка рівня стресу/вигорання',
                'Передплата на рік 1608 грн.',
                '2 сесії тестування на день',
                'Оцінка викривлення уваги',
                'Оцінка тривожності та/або депресії',
                'Рекомендації та інсайти'
            ],
            fullPrice: 780,
            price: 59.99,
            total: 780,
            value: 67,
            btnText: 'Передплатити',
            sub: '/m',
            subscription: true
        },
        {
            position: 2,
            title: '',
            header_description: '',
            isBestValue: false,
            recommendations: [
                'AI асистент. Beta версія',
                'Оцінка рівня стресу/вигорання',
                'Передплата на місяць',
                '2 сесії тестування на день',
                'Оцінка викривлення уваги',
                'Оцінка тривожності та/або депресії',
                'Рекомендації та інсайти'
            ],
            fullPrice: 134,
            price: 39.99,
            value: 134,
            btnText: 'Передплатити',
            subscription: true
        }
    ];

    loading = false;
    showSuccessMessage = false;

    constructor(
        private modalService: NgbModal,
        private data: PlansDataService,
        private auth: AuthService,
        private service: TherapistService,
        private route: ActivatedRoute,
        private dataService: DataService,
        private promoHandler: PromoHandlerService,
        private toaster: ToastrService,
        private router: Router,
        private scroll: ViewportScroller
    ) {

    }

    ngOnInit(): void {

        this.items = this.planSetDefaultData;
        let planId = localStorage.getItem('pid') !== '8b5d8282' ? '0b48f3f3' : '8b5d8282';

        this.route.fragment.subscribe((fragment: string) => {
            if (fragment && fragment.indexOf('p=') > -1) {
                planId = fragment.split('p=')[1];
                localStorage.setItem('pid', planId);
            }
        });
        this.getPlan()
            .subscribe(() => {
            }, (err) => {
                localStorage.removeItem('pid');
                if (err.status === 404) {
                    this.getPlan()
                        .subscribe();
                }
            });
    }

    getPlan() {
        const plansetEndpoint = this.service.isTherapistApp() ? 'therapist' : 'default';
        return this.data.getPlans(this.environment.apiUrl, plansetEndpoint)
            .pipe(
                map((res: any) => {
                    this.items.forEach((item: any) => {
                        const remoteItem: any = res.find((el: any, i: number) => i === +item.position);
                        item.description = remoteItem?.description;
                        item.id = remoteItem?.id;
                        item.value = remoteItem?.value;
                        item.total = remoteItem?.total;
                        item.size = remoteItem?.size;
                        item.currency = remoteItem?.currency;
                        item.type = remoteItem?.type;
                    });

                    if (this.route.snapshot.queryParams?.upgradeAi) {
                        this.router.navigate([], {replaceUrl: false})
                            .then(() => {
                                this.scroll.scrollToAnchor('plans');
                                const aiPlan = this.items.find((el: any) => el === 'AI-assistant');
                                this.onPay(aiPlan.subscription, aiPlan, true);
                            });

                    }
                    this.loaded.emit(true);
                    return res;
                })
            );
    }

    openAuthModal(): Promise<any> {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        return modalRef.result;
    }

    userData() {
        return new Promise((resolve, reject) => {
            this.auth.userSubscription().subscribe((docSnapshot: any) => {
                const data = docSnapshot.payload.data();
                if (data) {
                    resolve(data);
                }
            }, reject);
        });
    }

    onPay(subscription, plan, isUpdate = false) {
        if (this.auth.isLoggedIn) {
            this.openPaymentModal(subscription, plan, isUpdate);
        } else {
            this.openAuthModal()
                .then((res) => {
                    if (res) {
                        this.openPaymentModal(subscription, plan, isUpdate);
                    }
                });
        }
    }

    pay(prop, subscription: boolean) {
        this.loading = true;
        this.data.pay(this.environment.apiUrl, prop, subscription)
            .subscribe((res: any) => {
                this.dataService.orderId = subscription ? res.subscription_id : res.order_id;
                this.dataService.orderType = subscription ? 'subscription' : 'package';
                if (res.checkout_url) {
                    this.openLiqPayUrl(res.checkout_url);
                    this.loading = false;
                    this.promoHandler.localPromoCode = null;
                } else {
                    this.loading = false;
                    this.promoHandler.localPromoCode = null;
                }


            }, (err) => {
                this.showError(err.error?.detail);
                this.loading = false;
            });
    }

    showError(error: string) {
        switch (error) {
            case 'already-subscribed':
                return this.toaster.info('Ви вже підписані');
            default:
                return this.toaster.error('Сталася помилка. Спробуйте пізніше');
        }
    }

    openLiqPayUrl(url: string) {
        window.open(url, '_self');
    }

    openPaymentModal(subscription, plan: any, isUpdate = false) {
        const modalRef = this.modalService.open(PaymentComponent, {
            centered: true,
            windowClass: 'modal payment',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.isUpdate = isUpdate;
        modalRef.componentInstance.requestType = this.requestType;
        modalRef.componentInstance.plan = plan;
        modalRef.componentInstance.successRoute = this.successRoute;
        modalRef.componentInstance.submitButtonText = this.submitButtonText;
        modalRef.result.then(
            (res) => {
                if (res) {
                    plan.discount_id = res?.discount_id;
                    plan.referrer_id = this.promoHandler.localPromoCode;
                    this.pay(plan, subscription);
                }
            }, (err) => {
                console.log(err);
            }
        ).catch(err => {
            console.log(err);
        });
    }
}
